import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import GlobalPlatformParameters from "../../../../../shared/src/ranj/equalture/platform/GlobalPlatformParameters";
import InitPlatformAPIServiceTask from "../../../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask";
import PlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIService";
import GameModel from "../core/model/GameModel";
import CollaborationMockAPI from "./CollaborationMockAPI";
import CollaborationPlatformAPIService from "./CollaborationPlatformAPIService";

export default class CollaborationInitPlatformAPIServiceTask extends InitPlatformAPIServiceTask {
    
    /**
     * @param {Config} config 
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {AppModel} appModel
     * @param {SaveModel} saveModel
     * @param {GameModel} gameModel
     */
    constructor(config, injector, commands, appModel, saveModel, gameModel) {
        super(config, injector, commands, appModel, saveModel);
        this._gameModel = gameModel;
    }

    /**
     * @param {PlatformAPIService} platformAPIService
     * @param {string} appId 
     * @param {string} version 
     */
    async _initializeService(platformAPIService, appId, version) {
        platformAPIService.initialize(version);
        const parameters = await platformAPIService.getGlobalConfigurationAsync();
        this._applyGlobalPlatformConfiguration(parameters);
    }

    /**
     * Applies platform configuration/ parameters to game models.
     * @param {GlobalPlatformParameters} platformParameters 
     */
    _applyGlobalPlatformConfiguration(platformParameters) {
        this._appModel.language = getURLParameter("lang") ?? platformParameters.language;
        this._appModel.playMode = getURLParameter("mode") ?? platformParameters.playMode;
        this._appModel.environment = platformParameters.environment;

        this._gameModel.setScenarioStatesFromObject(platformParameters.payload.episodes);
    };

    MOCK_API_TYPE = CollaborationMockAPI;
    PLATFORM_API_SERVICE_TYPE = CollaborationPlatformAPIService;
}